import React from 'react';
import { LinearProgress, Box } from '../../../../third-party-components/material-ui';

const TaskProgress = ({completed = 0, style}) => {
  return(
    <Box style={style} className="task-progress">
        <LinearProgress
          variant="determinate"
          value={completed} />
        <div className="task-progress-text">{`${completed.toFixed(0)}%`}</div>
    </Box>
)}

export default TaskProgress; 